// Generate a real, downloadable PDF from the brochure pages.
// Each .page DOM node (already sized as A4 portrait in CSS) becomes one PDF page.
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export async function downloadBrochurePdf({
  selector = ".page",
  filename = "INPACE-POWER-Brochure.pdf",
  onProgress,
} = {}) {
  const pages = Array.from(document.querySelectorAll(selector));
  if (!pages.length) throw new Error("No brochure pages found");

  // A4 in mm
  const PDF_W = 210;
  const PDF_H = 297;

  const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });

  for (let i = 0; i < pages.length; i++) {
    onProgress?.(i, pages.length);
    const node = pages[i];

    // Render the DOM page to a canvas at 2x for crisp print quality.
    const canvas = await html2canvas(node, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#0b0908",
      logging: false,
      windowWidth: node.scrollWidth,
      windowHeight: node.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.92);

    if (i > 0) pdf.addPage();
    pdf.addImage(imgData, "JPEG", 0, 0, PDF_W, PDF_H, undefined, "FAST");
  }

  onProgress?.(pages.length, pages.length);
  pdf.save(filename);
}
